import { HeaderActions, HeaderNav } from "@sainsburys-tech/luna-header";
import { ListGroup, ListGroupDropdown, ListGroupItem } from "@sainsburys-tech/luna-list";
import { Account, Home } from "@sainsburys-tech/luna-icons";
import { useSelector } from "react-redux";
import { useDebugValue, useEffect, useState } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import routes from "../../../RouteConfig/routespath";
import { IRoute } from "../../../Interfaces/IRoute";
import { userType } from "../../../Types/user";
import { signoutRedirect } from "../../../Authorization/authService";
import "./navbar.scss";
import { getMenu } from "./navbaritem";
import store from "../../../Store/store";
import { storeFilter } from "../../../Redux/Actions/filterActions";
import { filterPayloadType } from "../../../Types/filterPayloadType";
import { menuHeaderPayload } from "../../../Redux/Actions/menuHeaderAction";
import { dispatchMessageFormatter } from "../../../helpers/dispatchMessageFormatter";
import { filterModelSelecterAndProcessData } from "../../../helpers/filterModelSelector";
import {
  LOCAL_STORAGE_CONSTANTS,
  UI_CONSTANTS,
} from "../../../Constants/constants";

const Navbar = () => {
  const [userDetails, setUserDetails] = useState<userType>();
  const [active, setActive] = useState(false);
  const [hover, setHover] = useState(false);
  const [navLinks, setNavLinks] = useState<IRoute[]>();

  const user = useSelector((state: any) => state.auth.user);
  const navs = useSelector((state: any) => state.menuItem);
  const history = useHistory();

  const location = useLocation();

  useEffect(() => {
    const isReload = localStorage.getItem(LOCAL_STORAGE_CONSTANTS.IS_RELOAD);
    if (isReload === "true") {
      const beforeRefreshStr = localStorage.getItem(
        LOCAL_STORAGE_CONSTANTS.BEFORE_REF_OBJ
      );

      if (beforeRefreshStr) {
        const refreshObj = JSON.parse(beforeRefreshStr);

        history.push(refreshObj?.path);
        store.dispatch(storeFilter(refreshObj.data));
      }
    }
  }, []);

  const filter = useSelector((state: any) => state.filterReducer);

  // })
  useEffect(() => {
    if (user !== null) {
      const userData: userType = {
        name: `${user.profile.firstName} ${user.profile.lastName}`,
        email: user.profile.email,
      };
      setUserDetails(userData);
    }
  }, [user]);

  useEffect(() => {
    if (user !== null) {
      let filterLinks;
      if (navs.length === 0) {
        filterLinks = routes;
      } else {
        filterLinks = [].concat.apply([], navs);
      }

      if (filterLinks.length > 1) {
        history.push(location.pathname);
      }
      setNavLinks(filterLinks);
    }
  }, [user, navs, history]);

  const signOut = () => {
    signoutRedirect();
  };

  const goHome = () => {
    history.push("/Home");
  };

  const onRouteClick = (
    path: string,
    headerSuffix: string,
    parentName: string | undefined,
    createPopupName: string | undefined,
    deletePopupName: string | undefined,
    searchPageReset: string | undefined
  ) => {
    //path in local
    let data;
    if (
      filter.data === null ||
      filter.data === undefined ||
      filter?.data?.codeScreen === UI_CONSTANTS.DASHBOARD ||
      path?.indexOf(UI_CONSTANTS.PRODUCT_PATH) === -1
    ) {
      data = dispatchMessageFormatter(
        "",
        true,
        "Navbar 78",
        headerSuffix,
        parentName,
        createPopupName,
        deletePopupName,
        searchPageReset,
        undefined,
        undefined,
        undefined,
        undefined,
        filter?.data?.nestedSearchId
      );
      store.dispatch(storeFilter(data));
      store.dispatch(menuHeaderPayload(null));
    } else if (
      filter.data?.parentName === parentName &&
      !filter.data?.isDirectQuery
    ) {
      data = dispatchMessageFormatter(
        "",
        true,
        "Navbar 81",
        headerSuffix,
        parentName,
        createPopupName,
        deletePopupName,
        searchPageReset,
        undefined,
        undefined,
        undefined,
        undefined,
        filter?.data?.nestedSearchId
      );
      store.dispatch(storeFilter(data));
    } else if (
      filter.data?.parentName !== parentName &&
      filter.data?.isDirectQuery
    ) {
      data = dispatchMessageFormatter(
        "",
        true,
        "Navbar 84",
        headerSuffix,
        parentName,
        createPopupName,
        deletePopupName,
        searchPageReset,
        undefined,
        undefined,
        undefined,
        undefined,
        filter?.data?.nestedSearchId
      );
      store.dispatch(storeFilter(data));
    } else if (
      filter.data?.parentName === parentName &&
      filter.data?.isDirectQuery
    ) {
      if (filter?.data?.nestedSearchId !== undefined) {
        let filterValue =
          filter?.data?.nestedSearchId !== undefined
            ? filter?.data?.nestedSearchId
            : ""; // filter.data.searchId;
        let filterData = filterModelSelecterAndProcessData(
          filterValue,
          `${parentName}/${headerSuffix}`
        );
        data = dispatchMessageFormatter(
          filterData,
          filter.data.isDirectQuery,
          "Navbar 93",
          headerSuffix,
          parentName,
          undefined,
          undefined,
          searchPageReset,
          undefined,
          undefined,
          headerSuffix,
          filter.data.data,
          filter?.data?.nestedSearchId
        );
        store.dispatch(storeFilter(data));
      } else {
        let qry =
          filter?.data?.previousQueryData !== undefined
            ? filter?.data?.previousQueryData
            : filter?.data?.data;
        data = dispatchMessageFormatter(
          searchPageReset === "fullPageReset" ? "" : qry,
          true,
          "Navbar 97",
          headerSuffix,
          parentName,
          createPopupName,
          deletePopupName,
          searchPageReset,
          undefined,
          undefined,
          undefined,
          undefined,
          filter?.data?.nestedSearchId
        );
        store.dispatch(storeFilter(data));
      }
    } else if (
      filter?.data?.parentName !== parentName &&
      !filter.data?.isDirectQuery
    ) {
      data = dispatchMessageFormatter(
        filter.data.data,
        filter.data.isDirectQuery,
        "Navbar 111",
        headerSuffix,
        parentName,
        createPopupName,
        deletePopupName,
        searchPageReset,
        undefined,
        undefined,
        filter.data.selectedMenu,
        undefined,
        filter?.data?.nestedSearchId
      );
      store.dispatch(menuHeaderPayload(data));
    }

    history.push(path, { HeaderName: headerSuffix });
    setBeforeRefreshObj(data, path, parentName, headerSuffix);
  };

  return (
    <>
      {user && user?.isLDMUser && (
        <HeaderNav openDropdownOnHover drawer tabBar="max-md" label="Main">
          {navLinks && getMenu(routes, onRouteClick, navLinks)}
        </HeaderNav>
      )}

      {user && (
        <HeaderActions align="right" label="Home and account">
          {user?.isLDMUser ? (
            <Link to="/Home" className="cursor" onClick={() => goHome()}>
              <Home />
              <span className="ln-u-visually-hidden">
                onClick={() => goHome()}
              </span>
            </Link>
          ) : (
            <></>
          )}

          <ListGroupDropdown
            id="account"
            active={active}
            hover={hover}
            onClick={(e: any) => {
              setActive(!active);
              e.preventDefault();
            }}
            onMouseEnter={(e) => {
              setHover(true);
            }}
            onMouseLeave={(e) => {
              setHover(false);
            }}
            onClose={(e) => {
              setActive(false);
            }}
          >
            <Account />
            <span className="ln-u-visually-hidden">Account</span>
            <ListGroup>
              <ListGroupItem>
                <span className="cursor-text">{userDetails?.name}</span>
              </ListGroupItem>
              <ListGroupItem>
                <Link to="/ldm-scan-download" className="cursor">
                  Download LDM Scan App
                </Link>
              </ListGroupItem>
              <ListGroupItem>
                <Link to="/" className="cursor" onClick={() => signOut()}>
                  Sign Out
                </Link>
              </ListGroupItem>
            </ListGroup>
          </ListGroupDropdown>
        </HeaderActions>
      )}
    </>
  );
};

export const setBeforeRefreshObj = (
  data: filterPayloadType | undefined,
  path: string | undefined,
  parentName: string | undefined,
  headerSuffix: string | undefined
) => {
  if (data?.isDirectQuery) {
    let beforeRefreshObject = {
      data: { ...data, data: "", previousQueryData: "", nestedSearchId: "" },
      path: path,
      parentName: parentName,
      headerSuffix: headerSuffix,
    };
    localStorage.setItem(
      LOCAL_STORAGE_CONSTANTS.BEFORE_REF_OBJ,
      JSON.stringify(beforeRefreshObject)
    );
    localStorage.setItem(LOCAL_STORAGE_CONSTANTS.IS_RELOAD, "false");
  }
};
export default Navbar;
